let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ikem6"), load("6wr18"), load("ffEVr"), load("1FzbR")]).then(() => parcelRequire('iWY6a'));